var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cx-wrap-scale",attrs:{"id":"cx-wrap-scale"}},[_c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.title),expression:"title"}]}),_vm._v(" "),_c('ScaleBox',[_c('div',{staticClass:"cx-layout"},[_c('headNavApp',{attrs:{"id":"main"}}),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('Footer')],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-784c67c7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/app/layout/HomeApp.vue
// module id = null
// module chunks = 